import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';
import { NoteTypeService } from 'src/app/services/information/note-type.service';
import { NoteTypeInfo, ReqAddNoteType } from 'src/app/models/information/note-type';
import { ActionEnum, StatusEnum } from 'src/app/models/common-enum';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import * as _ from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { permission } from 'src/app/views/information/_menu';
import { DateInputCustomFormatPlaceholder } from '@progress/kendo-angular-dateinputs';

@Component({
  selector: 'app-note-type',
  templateUrl: './note-type.component.html',
  styleUrls: ['../note.component.scss']
})
export class NoteTypeComponent implements OnInit {
  @ViewChild('addModal', { static: false }) public addModal: ModalDirective;
  @ViewChild('deleteModal', { static: false }) public deleteModal: ModalDirective;
  @ViewChild('swalSuccess', { static: false }) private swalSuccess: SwalComponent;
  @ViewChild('swalError', { static: false }) private swalError: SwalComponent;
  public formatPlaceholder: DateInputCustomFormatPlaceholder = {
    day: 'วัน',
    month: 'เดือน',
    year: 'ปี',
    hour: 'ชั่วโมง',
    minute: 'นาที',
    second: 'วินาที'
  };
  statusEnum = StatusEnum;
  myDate = new Date();
  currentPage: any = 1;
  itemsPerPage: any = 10;
  totalItems: any = 0;
  data_list: NoteTypeInfo[];
  status_list = [
    { id: StatusEnum.Active, name: "Active" },
    { id: StatusEnum.Inactive, name: "Inactive" }
  ];
  status: any;
  selectItem: any = {
    name: "",
    desc: ""
  };
  public allowCustom: boolean = false;
  res_message: any;
  status_modal: any;
  search_name: any;
  search_date: Date;
  isAdd: boolean = false;
  isEdit: boolean = false;
  constructor(private commonService: CommonService, private noteTypeService: NoteTypeService) { 
    this.commonService.activityLog(ActionEnum.Get, 'Information ➡ บันทึก ➡ ประเภทการบันทึก').subscribe(res => { }, error => { console.log(error); });
  }

  async ngOnInit() {
    //this.getRoute();
    this.is_loading = true;
    this.getData();
    this.isAdd = await this.commonService.getPermission(permission.data_bank.data_bank_type.add_id).toPromise();
    this.isEdit = await this.commonService.getPermission(permission.data_bank.data_bank_type.edit_id).toPromise();
  }

  handleValueStatus(value) {
    if (value) {
      this.status = value;
    } else {
      this.status = null;
    }
  }
  is_loading: boolean = false;

  search() {
    this.currentPage = 1;
    this.getData();
  }
  getData() {
    this.is_loading = true;
    this.data_list = [];
    let sta = null;
    if (this.status)
      sta = this.status.id;
    let st_time = null;
    let en_time = null;
    if(this.search_date){
      st_time = new Date(this.search_date.getFullYear(), this.search_date.getMonth(), this.search_date.getDate(), 0, 0, 0).toISOString();
      en_time = new Date(this.search_date.getFullYear(), this.search_date.getMonth(), this.search_date.getDate(), 23, 59, 59).toISOString();
    }
    this.noteTypeService.getNoteType(this.search_name, sta, st_time, en_time, this.currentPage, this.itemsPerPage).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            if (res.data) {
              this.data_list = res.data.data;
              this.totalItems = res.data.total_items;
            } else {
              this.totalItems = 0;
            }
          } else {
            this.totalItems = 0;
          }
        } else {
          this.totalItems = 0;
        }
        this.is_loading = false;
      },
      error => {
        this.is_loading = false;
        this.totalItems = 0;
      });
  }
  openAddModal() {
    this.selectItem = new NoteTypeInfo();
    this.selectItem.name = "";
    this.selectItem.desc = "";
    this.status_modal = this.status_list.find(x => x.id == StatusEnum.Active);
    this.addModal.show();
  }
  openEditModal(item?: any) {
    this.selectItem = item;
    this.status_modal = this.status_list.find(x => x.id == item.status);
    
    this.addModal.show();
  }
  openDeleteModal(item?: any) {
    this.selectItem = item;
    this.status_modal = this.status_list.find(x => x.id == item.status);
    this.deleteModal.show();
  }
  clearData() {
    this.selectItem = new NoteTypeInfo();
  }
  handleValueStatusModal(value) {
    if (value) {
      this.status_modal = value;
    } else {
      this.status_modal = null;
    }
  }
  pageChanged(event: any): void {
    if (this.currentPage != event.page) {
      this.currentPage = event.page;
      this.getData();
    }
  }
  addData() {
    this.is_loading = true;
    let req = new ReqAddNoteType();
    req.name = this.selectItem.name;
    req.desc = this.selectItem.desc;
    req.status = this.status_modal.id;
    this.res_message = "";
    this.noteTypeService.addNoteType(req).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { request: req, response: res };
            this.commonService.activityLog(ActionEnum.Add, 'Information ➡ บันทึก ➡ ประเภทการบันทึก', JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `เพิ่มประเภทการบันทึกสำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getData();
            }, 100);
            this.addModal.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }
  editData() {
    this.is_loading = true;
    let req = new ReqAddNoteType();
    req.name = this.selectItem.name;
    req.desc = this.selectItem.desc;
    req.status = this.status_modal.id;
    this.res_message = "";
    this.noteTypeService.editNoteType(req, this.selectItem.id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { id: this.selectItem.id, request: req, response: res };
            this.commonService.activityLog(ActionEnum.Edit, 'Information ➡ บันทึก ➡ ประเภทการบันทึก', JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `แก้ไขประเภทการบันทึกสำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getData();
            }, 100);
            this.addModal.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }

  deleteData() {
    this.is_loading = true;
    let req = new ReqAddNoteType();
    req.name = this.selectItem.name;
    req.desc = this.selectItem.desc;
    req.status = this.status_modal.id;
    this.res_message = "";
    this.noteTypeService.deleteNoteTypeEditStatus(req, this.selectItem.id).subscribe(
      res => {
        if (res) {
          if (res.code == 1) {
            const log_req_data = { id: this.selectItem.id };
            this.commonService.activityLog(ActionEnum.Delete, 'Information ➡ บันทึก ➡ ประเภทการบันทึก', JSON.stringify(log_req_data)).subscribe(res => { }, error => { console.log(error); });
            this.res_message = `ลบประเภทการบันทึกสำเร็จ`;
            setTimeout(() => {
              this.swalSuccess.fire();
              this.is_loading = false;
              this.getData();
            }, 100);
            this.deleteModal.hide();
          } else {
            this.res_message = res.message;
            setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
          }
        } else {
          setTimeout(() => { this.swalError.fire(); this.is_loading = false; }, 100);
        }
      },
      error => {
        console.log(error);
        if (error) {
          if (error.status == 403) {

          } else {
            const error_text = error.error.message || error.statusText;
            this.res_message = error_text;
            this.is_loading = false;
            setTimeout(() => { this.swalError.fire() }, 1000);
          }
        } else {
          setTimeout(() => { this.swalError.fire() }, 1000);
        }
        this.is_loading = false;
      });
  }

}